interface Props {
  className?: string;
  buttons: Array<{
    text: string;
    onClick?: (e?: any) => void;
    selected?: boolean;
  }>;
}

export const ButtonGroup = ({ buttons, className }: Props) => {
  return (
    <span
      className={`${className} relative z-0 inline-flex shadow-sm rounded-md`}>
      {buttons.map((b, i) => (
        <button
          key={i}
          type='button'
          className={`${
            i === buttons.length - 1
              ? 'rounded-r-md '
              : i === 0
              ? 'rounded-l-md '
              : ''
          } ${
            b.selected
              ? 'bg-green-default text-white'
              : 'bg-white text-gray-700'
          } relative inline-flex items-center px-4 py-2 border border-gray-300  text-sm font-medium hover:text-gray-700  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-green-default focus:border-green-default`}
          onClick={b.onClick}>
          {b.text}
        </button>
      ))}
    </span>
  );
};
